/**
 * bubu-leer.js — «Seguir leyendo» de los bloques largos de Bubu World.
 *
 * En móvil se ve el primer párrafo (los que diga el ajuste de la sección) y el resto se
 * despliega. Solo uno abierto a la vez: al abrir uno, el anterior se cierra, para que la
 * página no se estire. En PC no hay botón y el texto se ve completo (lo resuelve el CSS).
 */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-bubu-leer]');
  if (!btn) return;
  const caja = btn.closest('.bubu-leer');
  if (!caja) return;
  e.preventDefault();

  const abriendo = !caja.classList.contains('is-abierto');
  if (abriendo) {
    document.querySelectorAll('.bubu-leer.is-abierto').forEach((otra) => {
      if (otra !== caja) cierra(otra);
    });
  }
  caja.classList.toggle('is-abierto', abriendo);
  btn.setAttribute('aria-expanded', abriendo ? 'true' : 'false');
  const txt = btn.querySelector('[data-bubu-leer-txt]');
  if (txt) txt.textContent = abriendo ? btn.dataset.menos || 'Leer menos' : btn.dataset.mas || 'Seguir leyendo';
});

function cierra(caja) {
  caja.classList.remove('is-abierto');
  const b = caja.querySelector('[data-bubu-leer]');
  if (!b) return;
  b.setAttribute('aria-expanded', 'false');
  const t = b.querySelector('[data-bubu-leer-txt]');
  if (t) t.textContent = b.dataset.mas || 'Seguir leyendo';
}
